export const QBP_BLUE = '#1D2951'
export const QBP_BLUE_A50 = '#1D2951D0'
